import React from 'react';
import { Link, Navigate, useSearchParams } from 'react-router-dom'; // Import Link for navigation
import SignUpForm from '../components/auth/SignUpForm';
import primaryLogo from '../assets/logo/syncehs-lockup-black-v2.svg'; // Import the new logo

const SignUpPage: React.FC = () => {
  const [searchParams] = useSearchParams();

  // Organic (token-less) signup is retired — /get-started is the signup funnel.
  // Invite links (/signup?token=...) behave exactly as before. A Connect-accept
  // returnTo (set by ConnectAcceptRedirect via LoginPage) carries the invitation
  // token in its path; forward it as connect_token so the acceptance still
  // completes through the /get-started checkout (webhook phase).
  if (!searchParams.get('token')) {
    const returnTo = searchParams.get('returnTo');
    const connectPrefix = '/connect/accept/';
    const target = returnTo && returnTo.startsWith(connectPrefix)
      ? `/get-started?connect_token=${encodeURIComponent(returnTo.slice(connectPrefix.length))}`
      : '/get-started';
    return <Navigate to={target} replace />;
  }

  return (
    <div className="flex items-center justify-center min-h-screen bg-surface-bg">
      <div className="w-full max-w-md p-10 space-y-8 bg-surface-card rounded-xl shadow-lg">
        {/* Logo */}
        <div className="flex justify-center">
          <img
            className="h-auto w-60 max-w-full"
            src={primaryLogo}
            alt="SyncEHS Logo"
          />
        </div>
        <h2 className="font-display tracking-tight mt-6 text-3xl font-bold text-center text-text-primary">
          Create your SyncEHS account
        </h2>
        <SignUpForm />
        {/* Link to Login Page */}
        <p className="mt-8 text-sm text-center text-text-body">
          Already have an account?{' '}
          <Link to="/" className="font-medium text-accent-blue hover:text-accent-blue">
            Sign in
          </Link>
        </p>
      </div>
    </div>
  );
};

export default SignUpPage;

// Add empty export to satisfy '--isolatedModules'
export {};
